<template lang="pug">
  v-chip(
    label
    outline
    :color="statusColor"
  )
    span.text-none {{ statusText }}
</template>

<script>
import {
  DONE_STATUS, 
  DONE_WITH_ERRORS_STATUS, 
  PENDING_STATUS,
  BULK_ACTION_STATUS_LABELS,
} from '../config/bulk-actions-report-options';

export default {
  props: {
    status: {
      type: String,
    },
  },
  computed: {
    statusColor() {
      switch(this.status) {
        case DONE_STATUS:
          return 'green';
        case DONE_WITH_ERRORS_STATUS:
          return 'red';
        case PENDING_STATUS:
          return 'yellow';
      }
    },
    statusText() {
      return BULK_ACTION_STATUS_LABELS[this.status];
    },
  },
}
</script>
